define( function() {
	"use strict";

	return window.document;
} );



//////////////////
// WEBPACK FOOTER
// /srv/_versions/easypost-web/easypost-web-201706121922-6a92b31330-master/~/jquery/src/var/document.js
// module id = 17
// module chunks = 1